module.exports = __webpack_public_path__ + "img/weather.3635e39c.png";